import angular from 'angular';
import autocompleteComponent from './regulator-autocomplete.component';

export default angular.module('common.autocomplete.regulator', [])
  .component('regulatorAutocomplete', autocompleteComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/autocomplete/regulator/regulator-autocomplete.module.js